// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../rescript/lib/es6/curry.js";
import * as React from "react";
import * as ApiUtils$Catalyst from "../../../utils/ApiUtils.bs.js";
import * as LoadingViewComponent$Catalyst from "../../generic/loaders/LoadingViewComponent.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../error/ErrorDisplayComponent.bs.js";

function LoaderComponent(Config) {
  var getInitialState = function (param) {
    return /* Init */0;
  };
  var LoaderComponent$LoaderComponent = function (Props) {
    var fetchData = Props.fetchData;
    var initViewOpt = Props.initView;
    var loadingViewOpt = Props.loadingView;
    var renderView = Props.renderView;
    var initView = initViewOpt !== undefined ? initViewOpt : (function (param) {
          return React.createElement("div", undefined, "Init...");
        });
    var loadingView = loadingViewOpt !== undefined ? loadingViewOpt : (function (param) {
          return React.createElement(LoadingViewComponent$Catalyst.make, {});
        });
    var match = React.useReducer((function (_state, action) {
            switch (action.TAG | 0) {
              case /* LoadData */0 :
                  return {
                          TAG: /* Loading */0,
                          _0: action._0
                        };
              case /* LoadView */1 :
                  return {
                          TAG: /* Live */1,
                          _0: action._0
                        };
              case /* LoadErrorView */2 :
                  return {
                          TAG: /* Error */2,
                          _0: action._0
                        };
              
            }
          }), /* Init */0);
    var dispatch = match[1];
    var state = match[0];
    React.useEffect((function () {
            if (typeof state === "number") {
              Curry._1(dispatch, {
                    TAG: /* LoadData */0,
                    _0: undefined
                  });
            }
            
          }), []);
    React.useEffect((function () {
            if (typeof state !== "number" && state.TAG === /* Loading */0) {
              ApiUtils$Catalyst.handleAPIRequest((function (param) {
                      return Curry._1(fetchData, undefined);
                    }), (function (data) {
                      return Curry._1(dispatch, {
                                  TAG: /* LoadView */1,
                                  _0: data
                                });
                    }), (function (message) {
                      return Curry._1(dispatch, {
                                  TAG: /* LoadErrorView */2,
                                  _0: message
                                });
                    }));
            }
            
          }), [state]);
    if (typeof state === "number") {
      return Curry._1(initView, undefined);
    }
    switch (state.TAG | 0) {
      case /* Loading */0 :
          return Curry._1(loadingView, undefined);
      case /* Live */1 :
          return Curry._2(renderView, state._0, (function (param) {
                        return Curry._1(dispatch, {
                                    TAG: /* LoadData */0,
                                    _0: undefined
                                  });
                      }));
      case /* Error */2 :
          return React.createElement(ErrorDisplayComponent$Catalyst.make, {
                      error: state._0
                    });
      
    }
  };
  return {
          getInitialState: getInitialState,
          make: LoaderComponent$LoaderComponent
        };
}

function LoaderComponentWithoutRefresh(Config) {
  var getInitialState = function (param) {
    return /* Init */0;
  };
  var LoaderComponent$LoaderComponent = function (Props) {
    var fetchData = Props.fetchData;
    var initViewOpt = Props.initView;
    var loadingViewOpt = Props.loadingView;
    var renderView = Props.renderView;
    var initView = initViewOpt !== undefined ? initViewOpt : (function (param) {
          return React.createElement("div", undefined, "Init...");
        });
    var loadingView = loadingViewOpt !== undefined ? loadingViewOpt : (function (param) {
          return React.createElement(LoadingViewComponent$Catalyst.make, {});
        });
    var match = React.useReducer((function (_state, action) {
            switch (action.TAG | 0) {
              case /* LoadData */0 :
                  return {
                          TAG: /* Loading */0,
                          _0: action._0
                        };
              case /* LoadView */1 :
                  return {
                          TAG: /* Live */1,
                          _0: action._0
                        };
              case /* LoadErrorView */2 :
                  return {
                          TAG: /* Error */2,
                          _0: action._0
                        };
              
            }
          }), /* Init */0);
    var dispatch = match[1];
    var state = match[0];
    React.useEffect((function () {
            if (typeof state === "number") {
              Curry._1(dispatch, {
                    TAG: /* LoadData */0,
                    _0: undefined
                  });
            }
            
          }), []);
    React.useEffect((function () {
            if (typeof state !== "number" && state.TAG === /* Loading */0) {
              ApiUtils$Catalyst.handleAPIRequest((function (param) {
                      return Curry._1(fetchData, undefined);
                    }), (function (data) {
                      return Curry._1(dispatch, {
                                  TAG: /* LoadView */1,
                                  _0: data
                                });
                    }), (function (message) {
                      return Curry._1(dispatch, {
                                  TAG: /* LoadErrorView */2,
                                  _0: message
                                });
                    }));
            }
            
          }), [state]);
    if (typeof state === "number") {
      return Curry._1(initView, undefined);
    }
    switch (state.TAG | 0) {
      case /* Loading */0 :
          return Curry._1(loadingView, undefined);
      case /* Live */1 :
          return Curry._2(renderView, state._0, (function (param) {
                        return Curry._1(dispatch, {
                                    TAG: /* LoadData */0,
                                    _0: undefined
                                  });
                      }));
      case /* Error */2 :
          return React.createElement(ErrorDisplayComponent$Catalyst.make, {
                      error: state._0
                    });
      
    }
  };
  var BaseLoaderComponent = {
    getInitialState: getInitialState,
    make: LoaderComponent$LoaderComponent
  };
  var LoaderComponent$LoaderComponentWithoutRefresh = function (Props) {
    var fetchData = Props.fetchData;
    var initViewOpt = Props.initView;
    var loadingViewOpt = Props.loadingView;
    var renderView = Props.renderView;
    var initView = initViewOpt !== undefined ? initViewOpt : (function (param) {
          return React.createElement("div", undefined, "Init...");
        });
    var loadingView = loadingViewOpt !== undefined ? loadingViewOpt : (function (param) {
          return React.createElement(LoadingViewComponent$Catalyst.make, {});
        });
    return React.createElement(LoaderComponent$LoaderComponent, {
                fetchData: fetchData,
                initView: initView,
                loadingView: loadingView,
                renderView: (function (data, _onRefresh) {
                    return Curry._1(renderView, data);
                  })
              });
  };
  return {
          BaseLoaderComponent: BaseLoaderComponent,
          make: LoaderComponent$LoaderComponentWithoutRefresh
        };
}

export {
  LoaderComponent ,
  LoaderComponentWithoutRefresh ,
  
}
/* react Not a pure module */
